module.exports = __webpack_public_path__ + "img/182.0147a476.jpg";